import { literal, object, TypeOf } from 'zod';

import { ElementType } from '../common';

/* ----------------------------- TextPageElement ---------------------------- */

export const TextPageElement = object({
    type: literal(ElementType.Text),
});

export type TextPageElement = TypeOf<typeof TextPageElement>;
